import { render, staticRenderFns } from "./PaginaProtocollo.vue?vue&type=template&id=23d0666c"
import script from "./PaginaProtocollo.vue?vue&type=script&lang=js"
export * from "./PaginaProtocollo.vue?vue&type=script&lang=js"
import style0 from "./PaginaProtocollo.vue?vue&type=style&index=0&id=23d0666c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports